import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { enToPersianChar } from '../../../../components/helper'
import CustomValuesHook from '../../../../Hooks/customValuesHook'

const FeaturesTranslate = ({ feature }) => {
    const { t, i18n } = useTranslation()

    const [val, setVal] = CustomValuesHook({
        title: '',
        unit: '',
        count: ''
    })

    useEffect(() => {
        featurTitle(feature)
    }, [feature])


    const setCallDuratin = (feature) => {
        switch (feature?.count) {
            case 1: setVal({ title: t('HOURS_24'), unit: '', showCount: false })
                return
            case 2: setVal({ title: t('ON_YEAR'), unit: '', showCount: false })
                return
            case 3: setVal({ title: t('THREE_YEARS'), unit: '', showCount: false })
                return
        }
    }

    const setSupportType = (feature) => {
        switch (feature?.count) {
            case 1: setVal({ title: t('TICKET_ONLY'), unit: '', showCount: false })
                return
            case 2: setVal({ title: t('TICKET_AND_CALL'), unit: '', showCount: false })
                return
            case 3: setVal({ title: t('DEDICATED_SUPPORT'), unit: '', showCount: false })
                return
        }
    }


    const showDomain = (feature) => {
        if (feature?.count === -1) return setVal({ title: '', unit: '', showCount: true, count: t("UNLIMITED") })
        else return setVal({ title: t('DOMAIN-COUNT') + ':', unit: '', showCount: true, count: t("DOMAIN_UNIT") })

    }

    const featurTitle = (feature) => {
        setVal({ count: i18n.dir() === 'rtl' ? enToPersianChar(feature?.count) : feature?.count })
        switch (feature?.titel) {
            case 'Domain Count': showDomain(feature)
                return
            case 'CallQueue': setVal({ title: t('CALLQUEUE-COUNT'), unit: '', showCount: false })
                return
            case 'CallReport': setVal({ title: t('CALLREPORT-COUNT'), unit: '', showCount: false })
                return
            case 'CallStorageDuration': setCallDuratin(feature)
                return
            case 'InternalCall': setVal({ title: t('INTERNAL-COUNT'), unit: '', showCount: false })
                return
            case 'SupportType': setSupportType(feature)
                return
            case 'OccuranceCall': setVal({ title: t('OCCURANCECALL-COUNT'), unit: t('SYNC_CALL'), showCount: true })
        }

    }

    return (
        <div className='feature-item-text'>
            <span>{val?.title}</span>
            {val?.showCount && <span className='m-1'>{val?.count}</span>}
            <span>{val?.unit}</span>
        </div>
    )

}

export default FeaturesTranslate